module.exports = __webpack_public_path__ + "static/img/funny_26.53303a16.jpg";